"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useElementRef = void 0;
var react_1 = require("react");
var util_1 = require("./util");
var useElementRef = function (containerClassName, containerStyle) {
    var element = react_1.useMemo(function () { return util_1.createContainer(containerStyle, containerClassName); }, [
        containerClassName,
        containerStyle,
    ]);
    return react_1.useRef(element);
};
exports.useElementRef = useElementRef;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlRWxlbWVudFJlZi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy91c2VFbGVtZW50UmVmLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLCtCQUF3QztBQUN4QywrQkFBeUM7QUFFbEMsSUFBTSxhQUFhLEdBQUcsVUFDM0Isa0JBQTJCLEVBQzNCLGNBQTZDO0lBRTdDLElBQU0sT0FBTyxHQUFHLGVBQU8sQ0FBQyxjQUFNLE9BQUEsc0JBQWUsQ0FBQyxjQUFjLEVBQUUsa0JBQWtCLENBQUMsRUFBbkQsQ0FBbUQsRUFBRTtRQUNqRixrQkFBa0I7UUFDbEIsY0FBYztLQUNmLENBQUMsQ0FBQztJQUVILE9BQU8sY0FBTSxDQUFpQixPQUFPLENBQUMsQ0FBQztBQUN6QyxDQUFDLENBQUM7QUFWVyxRQUFBLGFBQWEsaUJBVXhCIn0=